import { inject, reactive, ref, provide, computed} from 'vue';

import Card from '@/components/content/views/card/card.vue';
import FormattingService from '@/services/formatting.service';
import Tooltip from '@/components/content/views/tooltip/tooltip.vue';
import SkeletonLoader from '@/components/content/views/skeleton-loader/skeleton-loader.vue';


export default {
  name: 'Article',
  props: {
    user: {
      type: Object,
      required: false
    },
    item: {
      type: Object,
      required: true,
    },
  },
  components: { 
    Card, 
    Tooltip, 
    SkeletonLoader,
  },  
  setup(props) {
    const state = reactive({
      member: computed(() => props.user),
      item: computed(() => props.item),
      loading: computed(() => props.loading),
      truncateBody: computed(() => {
        if(!state.item.content.rendered) return;
        if(state.item.content.rendered.length < 200) return state.item.content.rendered;
        return state.item.content.rendered.substring(0, 100)+'...';
      }),
      imageUrl: computed(() => {
        if(!state.item.images) return '';
        if(state.item.images['480w']) return state.item.images['480w'];
        if(state.item.images['720w']) return state.item.images['720w'];
        return state.item.images.full;       
      }) 
    });

    return {
      state,
      FormattingService,
    }
  }
}